const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/config/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ConfigParamSchema } from '@apps/main/features/admin/pages/config/config-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/config/')({
  validateSearch: ConfigParamSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});